var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21739",
    "data-name": "\\uADF8\\uB8F9 21739",
    transform: "translate(-1442 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21369",
    "data-name": "\\uADF8\\uB8F9 21369",
    transform: "translate(284 -682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_19_6",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 19 \\u2013 6",
    transform: "translate(1158 740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27582",
    "data-name": "\\uC0AC\\uAC01\\uD615 27582",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21361",
    "data-name": "\\uADF8\\uB8F9 21361",
    transform: "translate(1161.938 741.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10110",
    "data-name": "\\uD328\\uC2A4 10110",
    d: "M4.751,15.46V10.166a5.579,5.579,0,0,1,11.156,0V15.46",
    transform: "translate(-2.275 -2.238)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10111",
    "data-name": "\\uD328\\uC2A4 10111",
    d: "M7.006,25.618h7.4a1.757,1.757,0,0,1,.054,3.514H2.785a1.757,1.757,0,0,1-.055-3.514h.949",
    transform: "translate(-0.532 -11.972)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    y2: 1.757,
    transform: "translate(8.285 0.468)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10112",
    "data-name": "\\uD328\\uC2A4 10112",
    d: "M15.4,32.534a1.628,1.628,0,0,1-3.256,0",
    transform: "translate(-5.711 -14.041)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1207",
    "data-name": "\\uD0C0\\uC6D0 1207",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1461 60)",
    fill: "#ff6a13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.6fa4730b6cec23116ae308b854e8a602.svg";
export { ForwardRef as ReactComponent };